<template>
  <div class="login-background">
    <el-form>
      <div style="margin-bottom: 20px">
        <div style="color: white; font-size: 36px; font-weight: 600">
          Register
        </div>
      </div>
      <div>
        <div class="div_middle">
          <div class="div_register">
            <el-input
              v-model="register_name"
              maxlength="40"
              class="register_username"
              autocomplete="off"
              @input="name_input"
            ></el-input>
          </div>
          <!-- @blur="name_blur" -->
            <div
              id="div_name"
              style="display: block; margin-top: 5px; height: 80px"
            >
              <el-checkbox-group v-model="checkboxs">
                <el-checkbox
                  v-for="item in names"
                  :key="item.id"
                  :label="item.id"
                  :checked="item.ischeck"
                  >{{ item.details }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          <div style="clear: both"></div>
          <br />
          <div class="div_register">
            <el-input
              v-model="register_pass"
              maxlength="50"
              type="password"
              class="register_password"
              autoComplete="new-password"
            ></el-input>
          </div>
          <br />
          <div class="div_register">
            <el-input
              v-model="register_check"
              maxlength="50"
              type="password"
              class="register_password"
              autoComplete="new-password"
            ></el-input>
          </div>
        </div>
        <el-form-item>
          <div style="margin-top: 20px"></div>
          <el-button class="login-button">Login</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      register_name: "",
      register_pass: "",
      register_check: "",
      checkboxs: [],
      names: [
        { id: 1, details: "包含大写字母", ischeck: false },
        { id: 2, details: "字符长度超过8", ischeck: false },
        { id: 3, details: "包含小写字母", ischeck: false },
        { id: 4, details: "包含数字", ischeck: false },
      ],
    };
  },
  mounted() {},
  methods: {
    // name_blur() {
    //   debugger;
    //   var div_name = document.getElementById("div_name");
    //   div_name.style.display = "none";
    // },
    name_input() {
      // var div_name = document.getElementById("div_name");
      // div_name.style.display = "block";

      var tt = this.containsNumber(this.register_name);
      if (tt) {
        this.names[3].ischeck = true;
      }
      console.log(this.names);
    },
    containsNumber(str) {
      var reg = /\d/;
      return reg.test(str);
    },
  },
};
</script>
<style scoped>
.el-input {
  width: 390px;
}
.login-background {
  background: url("../assets/images/login_background.png") no-repeat;
  background-position: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  position: fixed;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.login-button {
  width: 390px;
  margin-top: 31px;
  height: 58px;
  font-size: 24px;
  border-radius: 0px;
  border: 0px;
  background: #ff8000;
  color: white;
}
.div_register {
  margin: 0 auto;
  width: 390px;
  height: 60px;
  line-height: 60px;
  background: rgba(255, 255, 255, 0.21);
}
.div_middle {
  margin: 0 auto;
  width: 390px;
}
.register_username {
  width: 390px;
  height: 60px;
  line-height: 60px;
  border-radius: 0px;
  font-size: 18px;
  color: #f9f9f9;
  box-sizing: border-box;
  border: none;
  -webkit-appearance: none; /*去除阴影边框*/
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*点击高亮的颜色*/
  background: url("../assets/images/user.png") no-repeat scroll 350px center
    transparent;
  background-size: 26px 26px;
}
.register_password {
  width: 390px;
  height: 60px;
  line-height: 60px;
  border-radius: 0px;
  font-size: 18px;
  color: #f9f9f9;
  box-sizing: border-box;
  border: none;
  -webkit-appearance: none; /*去除阴影边框*/
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*点击高亮的颜色*/
  background: url("../assets/images/password.png") no-repeat scroll 350px center
    transparent;
  background-size: 26px 26px;
}
</style>
<style >
.el-input__inner {
  width: 390px;
  height: 60px;
  line-height: 60px;
  border-radius: 0px;
  font-size: 18px;
  color: #f9f9f9;
  box-sizing: border-box;
  padding: 0 15px;
  border: none;
  -webkit-appearance: none; /*去除阴影边框*/
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*点击高亮的颜色*/
  background: transparent;
  background-size: 26px 26px;
}
/* .el-checkbox {
  width: 100%;
  text-align: left;
  padding-left: 5px;
} */
</style>


// WEBPACK FOOTER //
// src/components/Practice.vue